import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=540a069a&scoped=true&"
import script from "./remarks.vue?vue&type=script&lang=ts&"
export * from "./remarks.vue?vue&type=script&lang=ts&"
import style0 from "./remarks.vue?vue&type=style&index=0&id=540a069a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a069a",
  null
  
)

export default component.exports